import { useState } from "react";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const urlB64ToUint8 = (b64) => {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const AdminPushAlerts = () => {
  const [state, setState] = useState("idle");
  const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  if (!supported) return null;

  const enable = async () => {
    setState("busy");
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") {
        toast.error("Notifications are blocked in your browser settings.");
        setState("idle");
        return;
      }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await api.get("/push/vapid-key");
      if (!data.key) throw new Error("push not configured");
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8(data.key),
      });
      await api.post("/push/subscribe-admin", { subscription: sub.toJSON() });
      setState("done");
      toast.success("Lead alerts enabled — you'll get a notification for every new lead, chat and booking.");
    } catch {
      toast.error("Couldn't enable alerts on this device.");
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <p data-testid="admin-push-enabled" className="inline-flex items-center gap-2 text-sm text-sage">
        <Check size={15} /> Lead alerts on
      </p>
    );
  }
  return (
    <button type="button" data-testid="admin-push-enable" onClick={enable} disabled={state === "busy"}
      className="inline-flex items-center gap-2 rounded-full border border-sand-300 px-4 py-2 text-sm font-medium text-charcoal-700 hover:border-terracotta hover:text-terracotta disabled:opacity-60">
      <BellRing size={15} /> Enable lead alerts on this device
    </button>
  );
};
